// BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz
(() => {
  const LAYOUT_VERSION = 6;
  const arMobilLayout = () => window.matchMedia('(max-width: 64rem)').matches;
  const states = new WeakMap();

  const hamtaNiva = () => {
    if (window.matchMedia('(min-width: 64.0625rem)').matches) return 'wide';
    if (window.matchMedia('(min-width: 48.0625rem) and (max-width: 64rem)').matches) return 'medium';
    return 'narrow';
  };

  const hamtaData = (nyckel) => { try { return JSON.parse(localStorage.getItem(nyckel) || 'null'); } catch { return null; } };
  const sparaData = (nyckel, data) => { try { localStorage.setItem(nyckel, JSON.stringify(data)); } catch {} };

  const hamtaConfig = (sektion) => ({
    cellH: Math.max(3, +sektion.dataset.widgetCellH || 5),
    desktopKols: Math.max(1, +sektion.dataset.widgetDesktopCols || 6),
    desktopRows: Math.max(1, +sektion.dataset.widgetDesktopRows || 2),
    mobilKols: Math.max(1, +sektion.dataset.widgetMobileCols || 2),
    mobilRows: Math.max(1, +sektion.dataset.widgetMobileRows || 6)
  });

  const hamtaKolAntal = (niva, cfg) => {
    if (niva === 'narrow' || niva === 'medium') return cfg.mobilKols;
    return cfg.desktopKols;
  };

  const hamtaRadAntal = (niva, cfg) => (niva === 'narrow' || niva === 'medium' ? cfg.mobilRows : cfg.desktopRows);

  const hamtaGridKolStart = (yta) => {
    if (arMobilLayout()) return 2;
    const raw = getComputedStyle(yta).getPropertyValue('--grid-content').trim();
    const match = raw.match(/^(\d+)/);
    return match ? parseInt(match[1], 10) : 2;
  };

  const matLinjer = (yta, axel) => {
    const r = yta.getBoundingClientRect();
    const style = getComputedStyle(yta);
    const storlekar = (axel === 'x' ? style.gridTemplateColumns : style.gridTemplateRows).split(' ').map((s) => parseFloat(s) || 0);
    const gap = parseFloat(axel === 'x' ? style.columnGap : style.rowGap) || 0;
    const linjer = [axel === 'x' ? r.left : r.top];
    let pos = linjer[0];
    storlekar.forEach((storlek, i) => { pos += storlek; linjer.push(pos); if (i < storlekar.length - 1) pos += gap; });
    return linjer;
  };

  const pekaTillIndex = (linjer, pos) => {
    for (let i = 0; i < linjer.length - 1; i++) if (pos >= linjer[i] && pos < linjer[i + 1]) return i + 1;
    return Math.max(1, linjer.length - 1);
  };

  const cellTillPlacering = (kol, rad, kolSpan, radSpan, cfg, kolStart) => {
    const cellH = radSpan || cfg.cellH;
    const rowStart = 1 + (rad - 1) * (cfg.cellH + 1);
    return {
      colStart: kolStart + kol - 1,
      colEnd: kolStart + kol - 1 + kolSpan,
      rowStart,
      rowEnd: rowStart + cellH
    };
  };

  const standardPlacering = (index, niva, cfg, kolStart) => {
    const kolAntal = hamtaKolAntal(niva, cfg);
    const radAntal = hamtaRadAntal(niva, cfg);
    const rad = Math.min(Math.floor(index / kolAntal), radAntal - 1);
    const kol = index % kolAntal;
    return cellTillPlacering(kol + 1, rad + 1, 1, cfg.cellH, cfg, kolStart);
  };

  const hamtaSchemaPlacering = (item, niva, cfg, kolStart) => {
    if (niva === 'narrow' || niva === 'medium') return null;
    const kol = +item.dataset.desktopKol || 0;
    const rad = +item.dataset.desktopRad || 0;
    if (!kol || !rad) return null;
    const kolSpan = Math.max(1, +item.dataset.desktopKolSpan || 1);
    const radSpanRaw = +item.dataset.desktopRadSpan || 0;
    const radSpan = radSpanRaw > 0 ? radSpanRaw : cfg.cellH;
    return cellTillPlacering(kol, rad, kolSpan, radSpan, cfg, kolStart);
  };

  const arGiltig = (p, niva, cfg, kolStart) => {
    if (!p || !p.colStart || !p.colEnd || !p.rowStart || !p.rowEnd) return false;
    const kolAntal = hamtaKolAntal(niva, cfg);
    if (p.colEnd <= p.colStart || p.rowEnd <= p.rowStart) return false;
    if (p.colStart < kolStart || p.colEnd > kolStart + kolAntal) return false;
    if (p.rowEnd - p.rowStart < 3) return false;
    return true;
  };

  const appliceraPlacering = (item, placering) => {
    item.style.gridColumn = `${placering.colStart} / ${placering.colEnd}`;
    item.style.gridRow = `${placering.rowStart} / ${placering.rowEnd}`;
    item.dataset.widgetColStart = placering.colStart;
    item.dataset.widgetColEnd = placering.colEnd;
    item.dataset.widgetRowStart = placering.rowStart;
    item.dataset.widgetRowEnd = placering.rowEnd;
  };

  const uppdateraGridHojd = (yta, placeringar, cfg) => {
    let maxRad = cfg.cellH + 1;
    Object.values(placeringar).forEach((p) => { maxRad = Math.max(maxRad, p.rowEnd); });
    yta.style.setProperty('--widget-rows', maxRad + 1);
  };

  const hamtaMinRad = (item, cfg) => {
    const raw = +(item.dataset.mobilRadSpan && hamtaNiva() === 'narrow' ? item.dataset.mobilRadSpan : item.dataset.desktopRadSpan) || 0;
    return raw > 0 ? raw : cfg.cellH;
  };

  const rensaMobilPlacering = (yta, items) => {
    items.forEach((item) => {
      item.style.removeProperty('grid-column');
      item.style.removeProperty('grid-row');
      delete item.dataset.widgetColStart;
      delete item.dataset.widgetColEnd;
      delete item.dataset.widgetRowStart;
      delete item.dataset.widgetRowEnd;
    });
    yta.style.removeProperty('--widget-rows');
    yta.dataset.widgetLayout = 'klar';
  };

  const hamtaPlaceringar = (sektion, yta, items) => {
    if (arMobilLayout()) {
      rensaMobilPlacering(yta, items);
      return {};
    }
    const cfg = hamtaConfig(sektion);
    const niva = hamtaNiva();
    const kolStart = hamtaGridKolStart(yta);
    const nyckel = `bxyz-widgets-grid-${yta.dataset.widgetGridId}`;
    const sparad = hamtaData(nyckel);
    const sparadNiva = sparad?.v === LAYOUT_VERSION && sparad.layouts?.[niva]?.placeringar ? sparad.layouts[niva].placeringar : null;
    const placeringar = {};
    items.forEach((item, i) => {
      const sparadP = sparadNiva?.[item.dataset.widgetId];
      const schemaP = hamtaSchemaPlacering(item, niva, cfg, kolStart);
      const harSchema = schemaP && arGiltig(schemaP, niva, cfg, kolStart);
      const p = harSchema ? schemaP
        : arGiltig(sparadP, niva, cfg, kolStart) ? sparadP
        : standardPlacering(i, niva, cfg, kolStart);
      placeringar[item.dataset.widgetId] = p;
      appliceraPlacering(item, p);
    });
    uppdateraGridHojd(yta, placeringar, cfg);
    yta.dataset.widgetLayout = 'klar';
    return placeringar;
  };

  const sparaPlacering = (sektion, yta, item) => {
    if (arMobilLayout()) return;
    const nyckel = `bxyz-widgets-grid-${yta.dataset.widgetGridId}`;
    const niva = hamtaNiva();
    const data = hamtaData(nyckel) || { v: LAYOUT_VERSION, layouts: {} };
    if (!data.layouts[niva]) data.layouts[niva] = { placeringar: {} };
    data.layouts[niva].placeringar[item.dataset.widgetId] = {
      colStart: +item.dataset.widgetColStart,
      colEnd: +item.dataset.widgetColEnd,
      rowStart: +item.dataset.widgetRowStart,
      rowEnd: +item.dataset.widgetRowEnd
    };
    sparaData(nyckel, data);
    uppdateraGridHojd(yta, data.layouts[niva].placeringar, hamtaConfig(sektion));
  };

  const initStorlek = (sektion, yta, item, riktning, signal) => {
    if (arMobilLayout()) return;
    const knapp = item.querySelector(`[data-widget-storlek="${riktning}"]`);
    if (!knapp) return;
    knapp.addEventListener('pointerdown', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const cfg = hamtaConfig(sektion);
      const niva = hamtaNiva();
      const kolStart = hamtaGridKolStart(yta);
      const kolAntal = hamtaKolAntal(niva, cfg);
      const minRad = hamtaMinRad(item, cfg);
      const colLinjer = matLinjer(yta, 'x');
      const rowLinjer = matLinjer(yta, 'y');
      let colStartVal = +item.dataset.widgetColStart;
      let colEnd = +item.dataset.widgetColEnd;
      let rowStart = +item.dataset.widgetRowStart;
      let rowEnd = +item.dataset.widgetRowEnd;
      const maxColLinje = kolStart + kolAntal;
      item.dataset.tillstand = 'storlekandras';
      const flytta = (ev) => {
        if (riktning === 'vast') {
          colStartVal = Math.max(kolStart, Math.min(pekaTillIndex(colLinjer, ev.clientX), colEnd - 1));
        }
        if (riktning === 'ost' || riktning === 'sydost') {
          colEnd = Math.max(colStartVal + 1, Math.min(pekaTillIndex(colLinjer, ev.clientX), maxColLinje));
        }
        if (riktning === 'nord') {
          rowStart = Math.max(1, Math.min(pekaTillIndex(rowLinjer, ev.clientY), rowEnd - minRad));
        }
        if (riktning === 'syd' || riktning === 'sydost') {
          rowEnd = Math.max(rowStart + minRad, pekaTillIndex(rowLinjer, ev.clientY));
        }
        appliceraPlacering(item, { colStart: colStartVal, colEnd, rowStart, rowEnd });
      };
      const avsluta = () => {
        delete item.dataset.tillstand;
        document.removeEventListener('pointermove', flytta);
        document.removeEventListener('pointerup', avsluta);
        document.removeEventListener('pointercancel', avsluta);
        sparaPlacering(sektion, yta, item);
      };
      document.addEventListener('pointermove', flytta);
      document.addEventListener('pointerup', avsluta);
      document.addEventListener('pointercancel', avsluta);
    }, { signal });
  };

  const initGrid = async (sektion, signal) => {
    const yta = sektion.querySelector('[data-widget-grid]');
    if (!yta) return;
    const items = Array.from(yta.querySelectorAll('[data-widget-grid-item]'));
    if (!items.length) return;
    await new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));
    hamtaPlaceringar(sektion, yta, items);
    items.forEach((item) => ['vast', 'nord', 'ost', 'syd', 'sydost'].forEach((r) => initStorlek(sektion, yta, item, r, signal)));
    window.matchMedia('(max-width: 64rem)').addEventListener('change', () => hamtaPlaceringar(sektion, yta, items), { signal });
  };

  const bindSektion = (sektion) => {
    if (!sektion || states.has(sektion)) return;
    const ac = new AbortController();
    states.set(sektion, { ac });
    initGrid(sektion, ac.signal);
  };

  const rensaSektion = (sektion) => {
    const state = states.get(sektion);
    if (!state) return;
    state.ac.abort();
    states.delete(sektion);
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-widget-grid-sektion]').forEach(bindSektion);
  };

  if (!window._widgetsGridGlobal) {
    window._widgetsGridGlobal = true;
    document.addEventListener('shopify:section:load', (e) => initAll(e.target));
    document.addEventListener('shopify:section:unload', (e) => {
      e.target.querySelectorAll('[data-widget-grid-sektion]').forEach(rensaSektion);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
})();
